import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { PA_SPONSOR_OBJECTS } from "../keys";

const usePARightsholders = () => {
  const tenant = useSelector((state) => state.auth.tenant);

  return useQuery({
    queryKey: [PA_SPONSOR_OBJECTS, tenant.id],
    queryFn: () => ApiService.getPlacementAnalysisRightsholders(),
    select: (data) => data.data,
    placeholderData: { data: [] },
    enabled: ['sponsor', 'association'].includes(tenant.type),
  });
};

export default usePARightsholders;
